export default __webpack_public_path__ + "static/media/bg-beta.23f41d43.jpg";